import React from "react";
import { useGetPortfolioQuery } from "../../../graphql/generated";
import useAppLoader from "../../../Providers/AppLoaderProvider/hooks/useAppLoader";
import HomeLayout from "./comps/HomeLayout";

const Home = () => {
  const { loading, setLoading } = useAppLoader();
  const { data } = useGetPortfolioQuery({
    variables: {
      id: process.env.REACT_APP_PORTFOLIO_ID || "",
    },
    onCompleted: () => {
      if (loading) setLoading(false);
    },
  });

  return data?.getPortfolio ? (
    <HomeLayout portfolioData={data.getPortfolio} />
  ) : null;
};

export default Home;
